module.exports = __webpack_public_path__ + "img/21.c684f553.png";